// Total / subtotal row filter. Ported from CPAiSuite Universal (spec §4.5 / Tech Spec §6.3).
//
// Matches "Total", "Totals", "Grand Total", "Subtotal", "Sub-Total", and
// asterisk-wrapped variants like "***Total***", case-insensitively, in any of
// the first three cells.
//
// NOTE: the matcher accepts the optional trailing "s" ("Totals") because real
// provider exports use it (e.g. the Gusto sample's grand-total row reads
// "Totals"). The Functional Spec §3.4 examples ("Total", "Grand Total", ...) are
// a non-exhaustive list ("etc."); the trailing-s tolerance stays within that
// contract. See session notes — this widens the regex prescribed in the WS-8
// implementation prompt, which as written required a "sub" prefix and matched none
// of the documented cases.
const TOTAL_RE = /^\**\s*(grand\s+|sub-?)?totals?\s*\**$/i;

export function isTotalRow(row: string[]): boolean {
	return row.slice(0, 3).some((cell) => {
		const v = String(cell ?? '').trim();
		return v !== '' && TOTAL_RE.test(v);
	});
}
